function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $component, $helpers, Array, JSON, Math, Object, String, hoverTooltip) {
    var h = require("panel").h;
    var jade_mixins = {},
      $mixins = jade_mixins;
    jade_mixins['slope-svg'] = function(idx, startColor, stopColor, step, nextConvertedBarHeight) {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        const {
          value,
          conversionToNext,
          convertedBarHeight
        } = step;;
        const startY = 100 - convertedBarHeight;;
        const endY = 100 - nextConvertedBarHeight;;
        __jade_nodes = __jade_nodes.concat(h("svg", {
          "attrs": __vjadeStringifyAttrsIfObj({
            viewBox: `0 0 100 100`,
            preserveAspectRatio: `none`,
          }),
          "class": {
            'slope': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("defs", (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("linearGradient", {
              "attrs": __vjadeStringifyAttrsIfObj({
                id: `gradient-${idx}`,
                x1: `0%`,
                y1: `0%`,
                x2: `0%`,
                y2: `100%`,
              }),
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("stop", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  offset: `0%`
                }),
                "style": {
                  'stop-color': startColor,
                  'stop-opacity': 1
                },
              }));
              __jade_nodes = __jade_nodes.concat(h("stop", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  offset: `100%`
                }),
                "style": {
                  'stop-color': stopColor,
                  'stop-opacity': 1
                },
              }));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat(h("polygon", {
            "attrs": __vjadeStringifyAttrsIfObj({
              points: `0,${startY} 100,${endY} 100,100 0,100`
            }),
            "style": {
              fill: `url(#gradient-${idx})`
            },
          }));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['bar-tool-tip'] = function() {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "style": hoverTooltip.styles,
          "class": {
            'bar-tooltip-wrapper': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-chart-tooltip", {
            "attrs": __vjadeStringifyAttrsIfObj($helpers.getTooltipAttrs()),
          }));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['bar'] = function({
      step,
      stepIdx,
      bar,
      barIdx,
      isComparison = false
    } = {}) {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "style": {
            'margin-left': `${barIdx === 0 ? 0 : $helpers.getMarginBetweenBarSegments()}px`
          },
          "class": Object.assign({}, {
            'multi-bar': $component.hasMultipleSeries
          }, {
            'bar-wrapper': true
          }),
        }, (function() {
          var __jade_nodes = [];
          const hasDropOff = !$attr(`disable-drop-off-viz`) && $helpers.hasDropOff(stepIdx, barIdx, step);
          __jade_nodes = __jade_nodes.concat(($component.hasMultipleSeries && !$attr(`v2-design`)) ? ((function() {
            var __jade_nodes = [];
            const barHeight = Math.min(bar.convertedBarHeight + bar.dropOffBarHeight, 100);
            __jade_nodes = __jade_nodes.concat(h("div", {
              "style": {
                top: `calc(${100 - (barHeight)}% - 20px)`,
              },
              "class": {
                'count-text': true
              },
            }, [__vjadeSafeCode($helpers.abbreviateNumber3SigFigs(bar.value))]));;
            return __jade_nodes
          }).call(this)) : undefined);
          __jade_nodes = __jade_nodes.concat((hasDropOff) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "style": $helpers.getBarStyle({
                bar,
                barIdx,
                barType: $helpers.BarType.DROP_OFF
              }),
              "on": {
                click: $helpers.selectBar(stepIdx, barIdx, $helpers.BarType.DROP_OFF),
                mousemove: ev => $helpers.handleMouseMove(stepIdx, barIdx, $helpers.BarType.DROP_OFF, isComparison, ev),
                mouseleave: $helpers.handleMouseLeave,
              },
              "class": Object.assign({}, {
                'selected': $helpers.isSelected(stepIdx, barIdx, $helpers.BarType.DROP_OFF),
                'unselected': $helpers.isUnselected(stepIdx),
                'is-not-clickable': $attr(`disable-drop-off-click`),
                'highlighted': $helpers.isHighlighted(stepIdx, barIdx, $helpers.BarType.DROP_OFF),
                'rounded-top': true,
                'multi-bar': $component.hasMultipleSeries,
              }, {
                'drop-off-bar': true
              }),
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(($attr(`v2-design`)) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "style": $helpers.getStripedMaskStyle(barIdx),
                  "class": {
                    'striped-mask': true
                  },
                }));;
                return __jade_nodes
              }).call(this)) : undefined);;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this)) : undefined);
          __jade_nodes = __jade_nodes.concat(h("div", {
            "attrs": __vjadeStringifyAttrsIfObj({
              elref: `bar`
            }),
            "style": $helpers.getBarStyle({
              bar,
              barIdx,
              barType: $helpers.BarType.CONVERTED
            }),
            "on": {
              click: $helpers.selectBar(stepIdx, barIdx, $helpers.BarType.CONVERTED),
              mousemove: ev => $helpers.handleMouseMove(stepIdx, barIdx, $helpers.BarType.CONVERTED, isComparison, ev),
              mouseleave: $helpers.handleMouseLeave,
            },
            "class": Object.assign({}, {
              'selected': $helpers.isSelected(stepIdx, barIdx, $helpers.BarType.CONVERTED),
              'unselected': $helpers.isUnselected(stepIdx),
              'is-not-clickable': $attr(`disable-step-click`),
              'highlighted': $helpers.isHighlighted(stepIdx, barIdx, $helpers.BarType.CONVERTED),
              'rounded-top': !hasDropOff,
              'multi-bar': $component.hasMultipleSeries,
            }, {
              'bar': true
            }),
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(($helpers.shouldShowBarCountLabels()) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "style": $helpers.getBarLabelOffset(bar),
                "class": {
                  'bar-count-label': true
                },
              }, (function() {
                var __jade_nodes = [];
                const {
                  conversion,
                  conversionPercent
                } = $helpers.getBarLabel(bar);;
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'conversion-percent': true
                  },
                }, [__vjadeSafeCode(conversionPercent)]));
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'conversion': true
                  },
                }, [__vjadeSafeCode(conversion)]));;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this)) : undefined);;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    var __vjadeStringifyAttrsIfObj = function(attrs) {
      if (typeof attrs !== 'object') return attrs;
      const copy = {};
      for (const [k, v] of Object.entries(attrs)) {
        copy[k] = typeof attrs[k] === 'object' ? JSON.stringify(v) : v;
      }
      return copy;
    }

    var __vjadeSafeCode = function(code) {
      return code || String(code);
    };
    return {
      value: (h("div", {
        "on": {
          click: $helpers.unselectBarAndColumn
        },
        "style": {
          '--chart-height': $helpers.getChartHeightStyle(),
          '--grid-template-row-style': $helpers.getTemplateRowStyle(),
          '--y-axis-container-width': $helpers.getYAxisContainerWidth(),
          '--columns-left-margin': $helpers.getColumnsLeftMargin(),
        },
        "class": {
          'funnel-steps-chart': true
        },
      }, (function() {
        var __jade_nodes = [];
        const steps = $component.overallSteps;;
        const yAxisLabels = $helpers.getYAxisLabels(steps);;
        const {
          startColor,
          stopColor
        } = $helpers.getSlopeColor();;
        const noData = !$attr(`loading`) && steps.length === 0;
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": Object.assign({}, {
            griddable: !noData
          }, {
            'graph': true
          }),
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat((noData) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("slot", {
              "attrs": __vjadeStringifyAttrsIfObj({
                name: `empty-state`
              }),
            }));;
            return __jade_nodes
          }).call(this)) : (!$attr(`v2-design`)) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'y-axis-container': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'y-axis-label-header': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(($attr(`show-conversion-rate`)) ? ((function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "class": {
                      'completion-rate': true
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat($helpers.getUserCount());
                    __jade_nodes = __jade_nodes.concat(h("div", {
                      "class": {
                        'percentage': true
                      },
                    }, [__vjadeSafeCode($helpers.getUserConversionRate())]));;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));;
                  return __jade_nodes
                }).call(this)) : undefined);;
                return __jade_nodes
              }).call(this).filter(Boolean)));
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'y-axis-count-header': true
                },
              }));
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'y-axis-labels': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat((function() {
                  var $$obj = (yAxisLabels);
                  var $$eachNodes;
                  var $$iterated = false;
                  if (Array.isArray($$obj)) {
                    $$eachNodes = $$obj.reduce(function($$eachNodes, label, $index) {
                      $$iterated = true;
                      return $$eachNodes.concat((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("div", {
                          "style": {
                            'bottom': `${label.y * 100}%`
                          },
                          "class": {
                            'axis-label': true
                          },
                        }, [__vjadeSafeCode(label.text)]));;
                        return __jade_nodes
                      }).call(this));
                    }, []);
                  } else {
                    $$eachNodes = [];
                    for (var $$objKey in $$obj) {
                      (function() {
                        var $index = $$objKey;
                        if ($$obj.hasOwnProperty($index)) {
                          $$iterated = true;
                          var label = $$obj[$index];
                          $$eachNodes = $$eachNodes.concat((function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(h("div", {
                              "style": {
                                'bottom': `${label.y * 100}%`
                              },
                              "class": {
                                'axis-label': true
                              },
                            }, [__vjadeSafeCode(label.text)]));;
                            return __jade_nodes
                          }).call(this));
                        }
                      })();
                    }
                  }

                  return $$eachNodes;
                })());;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'y-axis-lines': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat((function() {
                var $$obj = (yAxisLabels);
                var $$eachNodes;
                var $$iterated = false;
                if (Array.isArray($$obj)) {
                  $$eachNodes = $$obj.reduce(function($$eachNodes, label, $index) {
                    $$iterated = true;
                    return $$eachNodes.concat((function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(h("div", {
                        "style": {
                          'bottom': `${$helpers.CHART_BAR_HEIGHT * label.y}px`
                        },
                        "class": {
                          'axis-line': true
                        },
                      }));;
                      return __jade_nodes
                    }).call(this));
                  }, []);
                } else {
                  $$eachNodes = [];
                  for (var $$objKey in $$obj) {
                    (function() {
                      var $index = $$objKey;
                      if ($$obj.hasOwnProperty($index)) {
                        $$iterated = true;
                        var label = $$obj[$index];
                        $$eachNodes = $$eachNodes.concat((function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("div", {
                            "style": {
                              'bottom': `${$helpers.CHART_BAR_HEIGHT * label.y}px`
                            },
                            "class": {
                              'axis-line': true
                            },
                          }));;
                          return __jade_nodes
                        }).call(this));
                      }
                    })();
                  }
                }

                return $$eachNodes;
              })());;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(h("div", {
              "on": {
                scroll: $helpers.handleScroll,
                wheel: $helpers.trackScroll,
              },
              "style": $helpers.getVariableColumnStyles(),
              "class": {
                'columns': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat((function() {
                var $$obj = (steps);
                var $$eachNodes;
                var $$iterated = false;
                if (Array.isArray($$obj)) {
                  $$eachNodes = $$obj.reduce(function($$eachNodes, step, idx) {
                    $$iterated = true;
                    return $$eachNodes.concat((function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(h("div", {
                        "on": {
                          click: () => $attr(`disable-header-click`) ? null : $helpers.selectColumn(idx)
                        },
                        "class": Object.assign({}, {
                          'is-clickable': $attr(`disable-header-click`) === false,
                          'selected': $attr(`selected-column`) === idx,
                          'unselected': $helpers.isUnselected(idx),
                        }, {
                          'step-label-header': true
                        }),
                      }, (function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("div", {
                          "class": {
                            'step-label': true
                          },
                        }, (function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("div", {
                            "class": {
                              'label-wrapper': true
                            },
                          }, (function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(h("div", {
                              "class": {
                                'title-wrapper': true
                              },
                            }, (function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat(h("div", {
                                "class": {
                                  'title': true
                                },
                              }, [__vjadeSafeCode(`${idx + 1}. ${step.title}`)]));;
                              return __jade_nodes
                            }).call(this).filter(Boolean)));
                            __jade_nodes = __jade_nodes.concat((step.subheader) ? ((function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat(h("div", {
                                "class": {
                                  'subheader': true
                                },
                              }, [__vjadeSafeCode(step.subheader)]));;
                              return __jade_nodes
                            }).call(this)) : undefined);;
                            return __jade_nodes
                          }).call(this).filter(Boolean)));
                          const displayTooltip = step.title.length > 25 || (step.subheader && step.subheader.length > 25);
                          __jade_nodes = __jade_nodes.concat((step.tooltipText && displayTooltip) ? ((function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                              "attrs": __vjadeStringifyAttrsIfObj({
                                placement: `bottom`,
                                'max-width': `300px`
                              }),
                            }, (function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat(h("span", {
                                "class": {
                                  'tooltip-text': true
                                },
                              }, [__vjadeSafeCode(step.tooltipText)]));;
                              return __jade_nodes
                            }).call(this).filter(Boolean)));;
                            return __jade_nodes
                          }).call(this)) : undefined);;
                          return __jade_nodes
                        }).call(this).filter(Boolean)));;
                        return __jade_nodes
                      }).call(this).filter(Boolean)));
                      __jade_nodes = __jade_nodes.concat(h("div", {
                        "class": {
                          'step-count-header': true
                        },
                      }, (function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat((!step.empty && !$component.hasMultipleSeries) ? ((function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("div", {
                            "class": Object.assign({}, {
                              'unselected': $helpers.isUnselected(idx)
                            }, {
                              'value': true
                            }),
                          }, [__vjadeSafeCode($helpers.countHeader(step))]));;
                          return __jade_nodes
                        }).call(this)) : undefined);;
                        return __jade_nodes
                      }).call(this).filter(Boolean)));
                      __jade_nodes = __jade_nodes.concat(h("div", {
                        "on": {
                          contextmenu: ev => $helpers.contextMenu(ev, step)
                        },
                        "class": Object.assign({}, {
                          'is-empty': step.empty,
                          'no-context-menu': $attr(`disable-context-menu`),
                        }, {
                          'step': true
                        }),
                      }, (function() {
                        var __jade_nodes = []; /*  step child elements are ordered by implicit z-index */
                        const firstBarInStep = $helpers.firstBarInStep(step);
                        const hasConversionToNext = $helpers.hasConversionToNext(step);
                        __jade_nodes = __jade_nodes.concat((hasConversionToNext) ? ((function() {
                          var __jade_nodes = [];
                          const nextBar = $helpers.firstBarInStep(steps[idx + 1]);
                          __jade_nodes = __jade_nodes.concat(jade_mixins['slope-svg'].call(this, idx, startColor, stopColor, firstBarInStep, nextBar.convertedBarHeight));;
                          return __jade_nodes
                        }).call(this)) : undefined);
                        __jade_nodes = __jade_nodes.concat((hasConversionToNext && !step.empty) ? ((function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("div", {
                            "style": $helpers.conversionArrowStyles(firstBarInStep, idx),
                            "class": {
                              'conversion-arrow': true
                            },
                          }, (function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat("" + ($helpers.formatPercent(firstBarInStep.conversionToNext, 1)) + "");
                            __jade_nodes = __jade_nodes.concat(h("div", {
                              "class": {
                                'conversion-arrow-triangle': true
                              },
                            }));;
                            return __jade_nodes
                          }).call(this).filter(Boolean)));;
                          return __jade_nodes
                        }).call(this)) : undefined);
                        __jade_nodes = __jade_nodes.concat((!step.empty) ? ((function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("div", {
                            "class": {
                              'bars-wrapper': true
                            },
                          }, (function() {
                            var __jade_nodes = [];
                            const isComparison = $helpers.hasComparison();
                            __jade_nodes = __jade_nodes.concat((function() {
                              var $$obj = (step.data);
                              var $$eachNodes;
                              var $$iterated = false;
                              if (Array.isArray($$obj)) {
                                $$eachNodes = $$obj.reduce(function($$eachNodes, bar, barIdx) {
                                  $$iterated = true;
                                  return $$eachNodes.concat((function() {
                                    var __jade_nodes = [];
                                    __jade_nodes = __jade_nodes.concat(jade_mixins['bar'].call(this, {
                                      step,
                                      stepIdx: idx,
                                      bar,
                                      barIdx,
                                      isComparison
                                    }));;
                                    return __jade_nodes
                                  }).call(this));
                                }, []);
                              } else {
                                $$eachNodes = [];
                                for (var $$objKey in $$obj) {
                                  (function() {
                                    var barIdx = $$objKey;
                                    if ($$obj.hasOwnProperty(barIdx)) {
                                      $$iterated = true;
                                      var bar = $$obj[barIdx];
                                      $$eachNodes = $$eachNodes.concat((function() {
                                        var __jade_nodes = [];
                                        __jade_nodes = __jade_nodes.concat(jade_mixins['bar'].call(this, {
                                          step,
                                          stepIdx: idx,
                                          bar,
                                          barIdx,
                                          isComparison
                                        }));;
                                        return __jade_nodes
                                      }).call(this));
                                    }
                                  })();
                                }
                              }

                              return $$eachNodes;
                            })());;
                            return __jade_nodes
                          }).call(this).filter(Boolean)));;
                          return __jade_nodes
                        }).call(this)) : undefined);;
                        return __jade_nodes
                      }).call(this).filter(Boolean)));;
                      return __jade_nodes
                    }).call(this));
                  }, []);
                } else {
                  $$eachNodes = [];
                  for (var $$objKey in $$obj) {
                    (function() {
                      var idx = $$objKey;
                      if ($$obj.hasOwnProperty(idx)) {
                        $$iterated = true;
                        var step = $$obj[idx];
                        $$eachNodes = $$eachNodes.concat((function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("div", {
                            "on": {
                              click: () => $attr(`disable-header-click`) ? null : $helpers.selectColumn(idx)
                            },
                            "class": Object.assign({}, {
                              'is-clickable': $attr(`disable-header-click`) === false,
                              'selected': $attr(`selected-column`) === idx,
                              'unselected': $helpers.isUnselected(idx),
                            }, {
                              'step-label-header': true
                            }),
                          }, (function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(h("div", {
                              "class": {
                                'step-label': true
                              },
                            }, (function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat(h("div", {
                                "class": {
                                  'label-wrapper': true
                                },
                              }, (function() {
                                var __jade_nodes = [];
                                __jade_nodes = __jade_nodes.concat(h("div", {
                                  "class": {
                                    'title-wrapper': true
                                  },
                                }, (function() {
                                  var __jade_nodes = [];
                                  __jade_nodes = __jade_nodes.concat(h("div", {
                                    "class": {
                                      'title': true
                                    },
                                  }, [__vjadeSafeCode(`${idx + 1}. ${step.title}`)]));;
                                  return __jade_nodes
                                }).call(this).filter(Boolean)));
                                __jade_nodes = __jade_nodes.concat((step.subheader) ? ((function() {
                                  var __jade_nodes = [];
                                  __jade_nodes = __jade_nodes.concat(h("div", {
                                    "class": {
                                      'subheader': true
                                    },
                                  }, [__vjadeSafeCode(step.subheader)]));;
                                  return __jade_nodes
                                }).call(this)) : undefined);;
                                return __jade_nodes
                              }).call(this).filter(Boolean)));
                              const displayTooltip = step.title.length > 25 || (step.subheader && step.subheader.length > 25);
                              __jade_nodes = __jade_nodes.concat((step.tooltipText && displayTooltip) ? ((function() {
                                var __jade_nodes = [];
                                __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                                  "attrs": __vjadeStringifyAttrsIfObj({
                                    placement: `bottom`,
                                    'max-width': `300px`
                                  }),
                                }, (function() {
                                  var __jade_nodes = [];
                                  __jade_nodes = __jade_nodes.concat(h("span", {
                                    "class": {
                                      'tooltip-text': true
                                    },
                                  }, [__vjadeSafeCode(step.tooltipText)]));;
                                  return __jade_nodes
                                }).call(this).filter(Boolean)));;
                                return __jade_nodes
                              }).call(this)) : undefined);;
                              return __jade_nodes
                            }).call(this).filter(Boolean)));;
                            return __jade_nodes
                          }).call(this).filter(Boolean)));
                          __jade_nodes = __jade_nodes.concat(h("div", {
                            "class": {
                              'step-count-header': true
                            },
                          }, (function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat((!step.empty && !$component.hasMultipleSeries) ? ((function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat(h("div", {
                                "class": Object.assign({}, {
                                  'unselected': $helpers.isUnselected(idx)
                                }, {
                                  'value': true
                                }),
                              }, [__vjadeSafeCode($helpers.countHeader(step))]));;
                              return __jade_nodes
                            }).call(this)) : undefined);;
                            return __jade_nodes
                          }).call(this).filter(Boolean)));
                          __jade_nodes = __jade_nodes.concat(h("div", {
                            "on": {
                              contextmenu: ev => $helpers.contextMenu(ev, step)
                            },
                            "class": Object.assign({}, {
                              'is-empty': step.empty,
                              'no-context-menu': $attr(`disable-context-menu`),
                            }, {
                              'step': true
                            }),
                          }, (function() {
                            var __jade_nodes = []; /*  step child elements are ordered by implicit z-index */
                            const firstBarInStep = $helpers.firstBarInStep(step);
                            const hasConversionToNext = $helpers.hasConversionToNext(step);
                            __jade_nodes = __jade_nodes.concat((hasConversionToNext) ? ((function() {
                              var __jade_nodes = [];
                              const nextBar = $helpers.firstBarInStep(steps[idx + 1]);
                              __jade_nodes = __jade_nodes.concat(jade_mixins['slope-svg'].call(this, idx, startColor, stopColor, firstBarInStep, nextBar.convertedBarHeight));;
                              return __jade_nodes
                            }).call(this)) : undefined);
                            __jade_nodes = __jade_nodes.concat((hasConversionToNext && !step.empty) ? ((function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat(h("div", {
                                "style": $helpers.conversionArrowStyles(firstBarInStep, idx),
                                "class": {
                                  'conversion-arrow': true
                                },
                              }, (function() {
                                var __jade_nodes = [];
                                __jade_nodes = __jade_nodes.concat("" + ($helpers.formatPercent(firstBarInStep.conversionToNext, 1)) + "");
                                __jade_nodes = __jade_nodes.concat(h("div", {
                                  "class": {
                                    'conversion-arrow-triangle': true
                                  },
                                }));;
                                return __jade_nodes
                              }).call(this).filter(Boolean)));;
                              return __jade_nodes
                            }).call(this)) : undefined);
                            __jade_nodes = __jade_nodes.concat((!step.empty) ? ((function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat(h("div", {
                                "class": {
                                  'bars-wrapper': true
                                },
                              }, (function() {
                                var __jade_nodes = [];
                                const isComparison = $helpers.hasComparison();
                                __jade_nodes = __jade_nodes.concat((function() {
                                  var $$obj = (step.data);
                                  var $$eachNodes;
                                  var $$iterated = false;
                                  if (Array.isArray($$obj)) {
                                    $$eachNodes = $$obj.reduce(function($$eachNodes, bar, barIdx) {
                                      $$iterated = true;
                                      return $$eachNodes.concat((function() {
                                        var __jade_nodes = [];
                                        __jade_nodes = __jade_nodes.concat(jade_mixins['bar'].call(this, {
                                          step,
                                          stepIdx: idx,
                                          bar,
                                          barIdx,
                                          isComparison
                                        }));;
                                        return __jade_nodes
                                      }).call(this));
                                    }, []);
                                  } else {
                                    $$eachNodes = [];
                                    for (var $$objKey in $$obj) {
                                      (function() {
                                        var barIdx = $$objKey;
                                        if ($$obj.hasOwnProperty(barIdx)) {
                                          $$iterated = true;
                                          var bar = $$obj[barIdx];
                                          $$eachNodes = $$eachNodes.concat((function() {
                                            var __jade_nodes = [];
                                            __jade_nodes = __jade_nodes.concat(jade_mixins['bar'].call(this, {
                                              step,
                                              stepIdx: idx,
                                              bar,
                                              barIdx,
                                              isComparison
                                            }));;
                                            return __jade_nodes
                                          }).call(this));
                                        }
                                      })();
                                    }
                                  }

                                  return $$eachNodes;
                                })());;
                                return __jade_nodes
                              }).call(this).filter(Boolean)));;
                              return __jade_nodes
                            }).call(this)) : undefined);;
                            return __jade_nodes
                          }).call(this).filter(Boolean)));;
                          return __jade_nodes
                        }).call(this));
                      }
                    })();
                  }
                }

                return $$eachNodes;
              })());;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this)) : ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat((!$attr(`no-grid`)) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'y-axis-container': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'y-axis-labels': true,
                    'v2': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat((function() {
                    var $$obj = (yAxisLabels);
                    var $$eachNodes;
                    var $$iterated = false;
                    if (Array.isArray($$obj)) {
                      $$eachNodes = $$obj.reduce(function($$eachNodes, label, $index) {
                        $$iterated = true;
                        return $$eachNodes.concat((function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("div", {
                            "style": {
                              'bottom': `${label.y * 100}%`
                            },
                            "class": {
                              'axis-label': true
                            },
                          }, [__vjadeSafeCode(label.text)]));;
                          return __jade_nodes
                        }).call(this));
                      }, []);
                    } else {
                      $$eachNodes = [];
                      for (var $$objKey in $$obj) {
                        (function() {
                          var $index = $$objKey;
                          if ($$obj.hasOwnProperty($index)) {
                            $$iterated = true;
                            var label = $$obj[$index];
                            $$eachNodes = $$eachNodes.concat((function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat(h("div", {
                                "style": {
                                  'bottom': `${label.y * 100}%`
                                },
                                "class": {
                                  'axis-label': true
                                },
                              }, [__vjadeSafeCode(label.text)]));;
                              return __jade_nodes
                            }).call(this));
                          }
                        })();
                      }
                    }

                    return $$eachNodes;
                  })());;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this).filter(Boolean)));
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'y-axis-lines-container': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'y-axis-lines': true,
                    'v2': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat((function() {
                    var $$obj = (yAxisLabels);
                    var $$eachNodes;
                    var $$iterated = false;
                    if (Array.isArray($$obj)) {
                      $$eachNodes = $$obj.reduce(function($$eachNodes, label, $index) {
                        $$iterated = true;
                        return $$eachNodes.concat((function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("div", {
                            "style": {
                              'bottom': `${label.y * 100}%`
                            },
                            "class": {
                              'axis-line': true,
                              'v2': true
                            },
                          }));;
                          return __jade_nodes
                        }).call(this));
                      }, []);
                    } else {
                      $$eachNodes = [];
                      for (var $$objKey in $$obj) {
                        (function() {
                          var $index = $$objKey;
                          if ($$obj.hasOwnProperty($index)) {
                            $$iterated = true;
                            var label = $$obj[$index];
                            $$eachNodes = $$eachNodes.concat((function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat(h("div", {
                                "style": {
                                  'bottom': `${label.y * 100}%`
                                },
                                "class": {
                                  'axis-line': true,
                                  'v2': true
                                },
                              }));;
                              return __jade_nodes
                            }).call(this));
                          }
                        })();
                      }
                    }

                    return $$eachNodes;
                  })());;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this)) : undefined);
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": Object.assign({}, {
                'no-grid': $attr(`no-grid`),
                'show-scrollbar': $attr(`show-scrollbar`),
              }, {
                'columns-v2-wrapper': true
              }),
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "on": {
                  scroll: $helpers.handleScroll,
                  wheel: $helpers.trackScroll,
                  /* tooltip has issues sometimes if the cursor leaves the bar too fast, so ensure we hide the tooltip if we leave the chart entirely */
                  mouseleave: $helpers.handleMouseLeave,
                },
                "style": $helpers.getVariableColumnStyles(),
                "class": Object.assign({}, {
                  'no-grid': $attr(`no-grid`)
                }, {
                  'columns-v2': true
                }),
              }, (function() {
                var __jade_nodes = [];
                let blankSteps = 0;
                __jade_nodes = __jade_nodes.concat(($helpers.shouldShowTooltip()) ? ((function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(jade_mixins['bar-tool-tip'].call(this));;
                  return __jade_nodes
                }).call(this)) : undefined);
                __jade_nodes = __jade_nodes.concat((function() {
                  var $$obj = (steps);
                  var $$eachNodes;
                  var $$iterated = false;
                  if (Array.isArray($$obj)) {
                    $$eachNodes = $$obj.reduce(function($$eachNodes, step, idx) {
                      $$iterated = true;
                      return $$eachNodes.concat((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat((step.empty) ? ((function() {
                          var __jade_nodes = [];
                          blankSteps += 1;
                          __jade_nodes = __jade_nodes.concat(h("div", {
                            "class": {
                              'scroll-snap-start': true,
                              'offset-placeholder': true
                            },
                          }));
                          __jade_nodes = __jade_nodes.concat(h("div", {
                            "class": {
                              'offset-placeholder': true
                            },
                          }));
                          __jade_nodes = __jade_nodes.concat(h("div", {
                            "class": {
                              'step-label-container': true
                            },
                          }, (function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(h("div", {
                              "class": {
                                'step-title-wrapper': true
                              },
                            }, (function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat(h("div", {
                                "class": {
                                  'step-title': true
                                },
                              }, [__vjadeSafeCode(`-`)]));;
                              return __jade_nodes
                            }).call(this).filter(Boolean)));;
                            return __jade_nodes
                          }).call(this).filter(Boolean)));;
                          return __jade_nodes
                        }).call(this)) : ((function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("div", {
                            "class": {
                              'margin': true
                            },
                          }));
                          __jade_nodes = __jade_nodes.concat(h("div", {
                            "attrs": __vjadeStringifyAttrsIfObj({
                              elref: `step`
                            }),
                            "on": {
                              contextmenu: ev => $helpers.contextMenu(ev, step)
                            },
                            "class": Object.assign({}, {
                              'no-context-menu': $attr(`disable-context-menu`),
                            }, {
                              'step': true,
                              'scroll-snap-start': true
                            }),
                          }, (function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(h("div", {
                              "class": {
                                'bars-wrapper': true
                              },
                            }, (function() {
                              var __jade_nodes = [];
                              const isComparison = $helpers.hasComparison();
                              __jade_nodes = __jade_nodes.concat((function() {
                                var $$obj = (step.data);
                                var $$eachNodes;
                                var $$iterated = false;
                                if (Array.isArray($$obj)) {
                                  $$eachNodes = $$obj.reduce(function($$eachNodes, bar, barIdx) {
                                    $$iterated = true;
                                    return $$eachNodes.concat((function() {
                                      var __jade_nodes = [];
                                      __jade_nodes = __jade_nodes.concat(jade_mixins['bar'].call(this, {
                                        step,
                                        stepIdx: idx,
                                        bar,
                                        barIdx,
                                        isComparison
                                      }));;
                                      return __jade_nodes
                                    }).call(this));
                                  }, []);
                                } else {
                                  $$eachNodes = [];
                                  for (var $$objKey in $$obj) {
                                    (function() {
                                      var barIdx = $$objKey;
                                      if ($$obj.hasOwnProperty(barIdx)) {
                                        $$iterated = true;
                                        var bar = $$obj[barIdx];
                                        $$eachNodes = $$eachNodes.concat((function() {
                                          var __jade_nodes = [];
                                          __jade_nodes = __jade_nodes.concat(jade_mixins['bar'].call(this, {
                                            step,
                                            stepIdx: idx,
                                            bar,
                                            barIdx,
                                            isComparison
                                          }));;
                                          return __jade_nodes
                                        }).call(this));
                                      }
                                    })();
                                  }
                                }

                                return $$eachNodes;
                              })());;
                              return __jade_nodes
                            }).call(this).filter(Boolean)));;
                            return __jade_nodes
                          }).call(this).filter(Boolean)));
                          __jade_nodes = __jade_nodes.concat(h("div", {
                            "class": {
                              'step-label-container': true
                            },
                          }, (function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(h("div", {
                              "class": {
                                'step-title-wrapper': true
                              },
                            }, (function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat(h("div", {
                                "class": {
                                  'step-title': true
                                },
                              }, (function() {
                                var __jade_nodes = [];
                                __jade_nodes = __jade_nodes.concat(step.title);;
                                return __jade_nodes
                              }).call(this).filter(Boolean)));
                              __jade_nodes = __jade_nodes.concat((step.tooltipText) ? ((function() {
                                var __jade_nodes = [];
                                __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                                  "attrs": __vjadeStringifyAttrsIfObj({
                                    placement: `top`,
                                    'max-width': `300px`,
                                    'offset': 0
                                  }),
                                }, (function() {
                                  var __jade_nodes = [];
                                  __jade_nodes = __jade_nodes.concat(h("span", {
                                    "class": {
                                      'tooltip-text': true
                                    },
                                  }, [__vjadeSafeCode(step.tooltipText)]));;
                                  return __jade_nodes
                                }).call(this).filter(Boolean)));;
                                return __jade_nodes
                              }).call(this)) : undefined);;
                              return __jade_nodes
                            }).call(this).filter(Boolean)));
                            __jade_nodes = __jade_nodes.concat(($helpers.includeStepCounts()) ? ((function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat(h("div", {
                                "class": {
                                  'step-counts': true
                                },
                              }, (function() {
                                var __jade_nodes = [];
                                __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                                  "attrs": __vjadeStringifyAttrsIfObj({
                                    icon: `value-absolute`
                                  }),
                                }));
                                __jade_nodes = __jade_nodes.concat(h("span", {
                                  "class": {
                                    'user-count': true
                                  },
                                }, [__vjadeSafeCode($helpers.countHeader(step))]));
                                __jade_nodes = __jade_nodes.concat(h("div", {
                                  "class": {
                                    'tooltip-wrapper': true
                                  },
                                }, (function() {
                                  var __jade_nodes = [];
                                  __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                                    "attrs": __vjadeStringifyAttrsIfObj({
                                      icon: `arrow-up`
                                    }),
                                  }));
                                  __jade_nodes = __jade_nodes.concat(h("span", {
                                    "class": {
                                      'conversion': true
                                    },
                                  }, [__vjadeSafeCode($helpers.getConversionRate(step))]));
                                  __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                                    "attrs": __vjadeStringifyAttrsIfObj({
                                      placement: `bottom`,
                                      'max-width': `300px`,
                                      'offset': 0
                                    }),
                                  }, (function() {
                                    var __jade_nodes = [];
                                    __jade_nodes = __jade_nodes.concat(h("span", {
                                      "class": {
                                        'tooltip-text': true
                                      },
                                    }, [__vjadeSafeCode(`Conversion from previous step`)]));;
                                    return __jade_nodes
                                  }).call(this).filter(Boolean)));;
                                  return __jade_nodes
                                }).call(this).filter(Boolean)));;
                                return __jade_nodes
                              }).call(this).filter(Boolean)));;
                              return __jade_nodes
                            }).call(this)) : undefined);;
                            return __jade_nodes
                          }).call(this).filter(Boolean)));;
                          return __jade_nodes
                        }).call(this)));;
                        return __jade_nodes
                      }).call(this));
                    }, []);
                  } else {
                    $$eachNodes = [];
                    for (var $$objKey in $$obj) {
                      (function() {
                        var idx = $$objKey;
                        if ($$obj.hasOwnProperty(idx)) {
                          $$iterated = true;
                          var step = $$obj[idx];
                          $$eachNodes = $$eachNodes.concat((function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat((step.empty) ? ((function() {
                              var __jade_nodes = [];
                              blankSteps += 1;
                              __jade_nodes = __jade_nodes.concat(h("div", {
                                "class": {
                                  'scroll-snap-start': true,
                                  'offset-placeholder': true
                                },
                              }));
                              __jade_nodes = __jade_nodes.concat(h("div", {
                                "class": {
                                  'offset-placeholder': true
                                },
                              }));
                              __jade_nodes = __jade_nodes.concat(h("div", {
                                "class": {
                                  'step-label-container': true
                                },
                              }, (function() {
                                var __jade_nodes = [];
                                __jade_nodes = __jade_nodes.concat(h("div", {
                                  "class": {
                                    'step-title-wrapper': true
                                  },
                                }, (function() {
                                  var __jade_nodes = [];
                                  __jade_nodes = __jade_nodes.concat(h("div", {
                                    "class": {
                                      'step-title': true
                                    },
                                  }, [__vjadeSafeCode(`-`)]));;
                                  return __jade_nodes
                                }).call(this).filter(Boolean)));;
                                return __jade_nodes
                              }).call(this).filter(Boolean)));;
                              return __jade_nodes
                            }).call(this)) : ((function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat(h("div", {
                                "class": {
                                  'margin': true
                                },
                              }));
                              __jade_nodes = __jade_nodes.concat(h("div", {
                                "attrs": __vjadeStringifyAttrsIfObj({
                                  elref: `step`
                                }),
                                "on": {
                                  contextmenu: ev => $helpers.contextMenu(ev, step)
                                },
                                "class": Object.assign({}, {
                                  'no-context-menu': $attr(`disable-context-menu`),
                                }, {
                                  'step': true,
                                  'scroll-snap-start': true
                                }),
                              }, (function() {
                                var __jade_nodes = [];
                                __jade_nodes = __jade_nodes.concat(h("div", {
                                  "class": {
                                    'bars-wrapper': true
                                  },
                                }, (function() {
                                  var __jade_nodes = [];
                                  const isComparison = $helpers.hasComparison();
                                  __jade_nodes = __jade_nodes.concat((function() {
                                    var $$obj = (step.data);
                                    var $$eachNodes;
                                    var $$iterated = false;
                                    if (Array.isArray($$obj)) {
                                      $$eachNodes = $$obj.reduce(function($$eachNodes, bar, barIdx) {
                                        $$iterated = true;
                                        return $$eachNodes.concat((function() {
                                          var __jade_nodes = [];
                                          __jade_nodes = __jade_nodes.concat(jade_mixins['bar'].call(this, {
                                            step,
                                            stepIdx: idx,
                                            bar,
                                            barIdx,
                                            isComparison
                                          }));;
                                          return __jade_nodes
                                        }).call(this));
                                      }, []);
                                    } else {
                                      $$eachNodes = [];
                                      for (var $$objKey in $$obj) {
                                        (function() {
                                          var barIdx = $$objKey;
                                          if ($$obj.hasOwnProperty(barIdx)) {
                                            $$iterated = true;
                                            var bar = $$obj[barIdx];
                                            $$eachNodes = $$eachNodes.concat((function() {
                                              var __jade_nodes = [];
                                              __jade_nodes = __jade_nodes.concat(jade_mixins['bar'].call(this, {
                                                step,
                                                stepIdx: idx,
                                                bar,
                                                barIdx,
                                                isComparison
                                              }));;
                                              return __jade_nodes
                                            }).call(this));
                                          }
                                        })();
                                      }
                                    }

                                    return $$eachNodes;
                                  })());;
                                  return __jade_nodes
                                }).call(this).filter(Boolean)));;
                                return __jade_nodes
                              }).call(this).filter(Boolean)));
                              __jade_nodes = __jade_nodes.concat(h("div", {
                                "class": {
                                  'step-label-container': true
                                },
                              }, (function() {
                                var __jade_nodes = [];
                                __jade_nodes = __jade_nodes.concat(h("div", {
                                  "class": {
                                    'step-title-wrapper': true
                                  },
                                }, (function() {
                                  var __jade_nodes = [];
                                  __jade_nodes = __jade_nodes.concat(h("div", {
                                    "class": {
                                      'step-title': true
                                    },
                                  }, (function() {
                                    var __jade_nodes = [];
                                    __jade_nodes = __jade_nodes.concat(step.title);;
                                    return __jade_nodes
                                  }).call(this).filter(Boolean)));
                                  __jade_nodes = __jade_nodes.concat((step.tooltipText) ? ((function() {
                                    var __jade_nodes = [];
                                    __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                                      "attrs": __vjadeStringifyAttrsIfObj({
                                        placement: `top`,
                                        'max-width': `300px`,
                                        'offset': 0
                                      }),
                                    }, (function() {
                                      var __jade_nodes = [];
                                      __jade_nodes = __jade_nodes.concat(h("span", {
                                        "class": {
                                          'tooltip-text': true
                                        },
                                      }, [__vjadeSafeCode(step.tooltipText)]));;
                                      return __jade_nodes
                                    }).call(this).filter(Boolean)));;
                                    return __jade_nodes
                                  }).call(this)) : undefined);;
                                  return __jade_nodes
                                }).call(this).filter(Boolean)));
                                __jade_nodes = __jade_nodes.concat(($helpers.includeStepCounts()) ? ((function() {
                                  var __jade_nodes = [];
                                  __jade_nodes = __jade_nodes.concat(h("div", {
                                    "class": {
                                      'step-counts': true
                                    },
                                  }, (function() {
                                    var __jade_nodes = [];
                                    __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                                      "attrs": __vjadeStringifyAttrsIfObj({
                                        icon: `value-absolute`
                                      }),
                                    }));
                                    __jade_nodes = __jade_nodes.concat(h("span", {
                                      "class": {
                                        'user-count': true
                                      },
                                    }, [__vjadeSafeCode($helpers.countHeader(step))]));
                                    __jade_nodes = __jade_nodes.concat(h("div", {
                                      "class": {
                                        'tooltip-wrapper': true
                                      },
                                    }, (function() {
                                      var __jade_nodes = [];
                                      __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                                        "attrs": __vjadeStringifyAttrsIfObj({
                                          icon: `arrow-up`
                                        }),
                                      }));
                                      __jade_nodes = __jade_nodes.concat(h("span", {
                                        "class": {
                                          'conversion': true
                                        },
                                      }, [__vjadeSafeCode($helpers.getConversionRate(step))]));
                                      __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                                        "attrs": __vjadeStringifyAttrsIfObj({
                                          placement: `bottom`,
                                          'max-width': `300px`,
                                          'offset': 0
                                        }),
                                      }, (function() {
                                        var __jade_nodes = [];
                                        __jade_nodes = __jade_nodes.concat(h("span", {
                                          "class": {
                                            'tooltip-text': true
                                          },
                                        }, [__vjadeSafeCode(`Conversion from previous step`)]));;
                                        return __jade_nodes
                                      }).call(this).filter(Boolean)));;
                                      return __jade_nodes
                                    }).call(this).filter(Boolean)));;
                                    return __jade_nodes
                                  }).call(this).filter(Boolean)));;
                                  return __jade_nodes
                                }).call(this)) : undefined);;
                                return __jade_nodes
                              }).call(this).filter(Boolean)));;
                              return __jade_nodes
                            }).call(this)));;
                            return __jade_nodes
                          }).call(this));
                        }
                      })();
                    }
                  }

                  return $$eachNodes;
                })());;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this)));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };

  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$component" in locals ? locals.$component : typeof $component !== "undefined" ? $component : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "Array" in locals ? locals.Array : typeof Array !== "undefined" ? Array : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Math" in locals ? locals.Math : typeof Math !== "undefined" ? Math : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "String" in locals ? locals.String : typeof String !== "undefined" ? String : undefined, "hoverTooltip" in locals ? locals.hoverTooltip : typeof hoverTooltip !== "undefined" ? hoverTooltip : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;